import React  from 'react';
import { List, TextField } from 'react-admin';
import { Create, SimpleForm, DisabledInput, TextInput, BooleanInput } from 'react-admin';
import {  Edit, Toolbar, SaveButton, DeleteButton } from 'react-admin';

//import { EditButton } from 'react-admin';


import {  Datagrid  } from 'react-admin';

import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

//import {  Tree, NodeView, NodeActions } from 'ra-tree-ui-materialui';
//import { DragPreview } from 'ra-tree-ui-materialui';

import AddFileIcon from '@material-ui/icons/NoteAdd';
import FilesIcon from '@material-ui/icons/LibraryBooks';
import EditIcon from '@material-ui/icons/Edit';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import InFolderIcon from '@material-ui/icons/VerticalAlignBottom';
import OutFolderIcon from '@material-ui/icons/VerticalAlignTop';
import HomeIcon from '@material-ui/icons/Home';


import Tooltip from '@material-ui/core/Tooltip';

import CardActions from '@material-ui/core/CardActions';

//import { EditButton } from 'react-admin';

  
  
const ListDocumentsButton = ({ record }) => 
 record    && record.active && record.id !== "1" && record.HasFiles  ?    (
                                    <Tooltip title="View Files">
                                      <Button 
                                          component={Link}
                                          to={{
                                              pathname: '/documents?filter={"folder":"' + record.id + '"}' 
                                          }}
                                      >
                                         <FilesIcon  />
                                      </Button>
                                    </Tooltip>
                                ) : null;

///

///
const CreateDocumentButton = ({ record }) => 
 record    && record.active && record.id !== "1" && !record.HasSubfolders ? (
                                    <Tooltip title="Add File">
                                      <Button
                                          component={Link}
                                          to={{
                                              pathname: '/files/create',
                                              state: { record: { folder: record.id } },
                                          }}
                                      >
                                          <AddFileIcon />
                                      </Button>
                                    </Tooltip>
                                ): null;
///
const CreateFolderButton = ({ record }) => 
 record     && record.active   ? (
                                  <Tooltip title="Add Sub Folder">
                                    <Button
                                        component={Link}
                                        to={{
                                            pathname: '/folders/create',
                                            state: { record: {  parent_id: record.id } },
                                        }}
                                    >
                                        <CreateNewFolderIcon />
                                    </Button>
                                  </Tooltip>
                                ): null;


///
const ListUserButton = ({ record }) => 
  record   &&   record.id !== "1" ?  (
                                    <Tooltip title="Permissions">
                                      <Button
                                          component={Link}
                                          to={{}}
                                      >
                                          { record.client === "0" ? "" :  " client [" + record.client + "]"        }
                                      </Button>
                                    </Tooltip>
                                ) : null ;
///
  
const EditFolderButton = ({ record }) => 
  record    && record.active ?  (
                                    <Tooltip title="Edit folder">
                                       <Button
                                          component={Link}
                                          to={{
                                              pathname: '/folders/' + record.id
                                          }}
                                      >
                                        <EditIcon />
                                      </Button>
                                    </Tooltip>
                                ) : null
                                 ;
 


const onClick = () => {
    window.history.go(-1);
}



 //pathname: '/folders?filter={"id":' + JSON.parse(localStorage.getItem("user")).Folder + ' }' 
const ListOutSubFoldersButton = ({ record }) => 
 record    && record.active && record.parent_id > 0 &&   record.parent_id > 1   ?    (
                                    <Tooltip title="Exit subfolders">
                                      <Button 
                                          component={Link}
                                          to={{ }}
                                          onClick={onClick}
                                      >
                                        
                                        <OutFolderIcon  /> 
                                      </Button>
                                    </Tooltip>
                                ) : null;


const ListSubFoldersButton = ({ record }) => 
 record    && record.active  && ( record.HasSubfolders  ) ?    (
                                     <Tooltip title="View subfolders">
                                       <Button 
                                           component={Link}
                                           to={{
                                               pathname: '/folders?filter={"parent_id":' + record.id +  '}' 
                                           }}
                                       >
                                         
                                           < InFolderIcon /> 
                                       </Button>
                                     </Tooltip>
                                 ) : null;
     



const HomeButton = ({ record }) => 
 (
                                    <Tooltip title="Back to home">
                                      <Button 
                                          component={Link}
                                          to={{
                                              pathname: '/folders?filter={"id":' + JSON.parse(localStorage.getItem("user")).Folder + ' }' 
                                          }}
                                      >
                                         <HomeIcon  /> 
                                      </Button>
                                    </Tooltip>
                                ) ;

 

const DeleteFolderButton = ({ record }) => 
     record &&   !record.HasSubfolders && !record.HasFiles ? (
            <DeleteButton record={record} resource="folders" />
        ) : null;

//        <DeleteButton />
/*const FoldersActions = props => (
    <NodeActions {...props}>
        <ListUserButton   />
        <EditFolderButton  />
        <CreateFolderButton />
         
        <ListDocumentsButton    />
    </NodeActions>
);
*/
///
/*
const FoldersActionsAdmin = props => (
    <NodeActions {...props}>
        <ListDocumentsButton   />
    </NodeActions>
);
*/
///
/*
const FoldersActionsClient = props => (
    <NodeActions {...props}>
        <ListUserButton />
        
        <CreateDocumentButton />
        <ListDocumentsButton />
    </NodeActions>
);
*/

///
const styles = {
    flex: { display: 'flex'  },
};
///
/*
const TagDragPreview = props => (
    <DragPreview {...props}>
        {({ node }) => "draging " + node.record.name}
    </DragPreview>
);
*/


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

/// enableDragAndDrop dragPreviewComponent={TagDragPreview}
  
const PostShowActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <HomeButton /> 
    </CardActions>
);
 
 /// client: ['0', JSON.parse(localStorage.getItem("user")).client],
export const FolderList = (props) => (
    <List {...props} perPage={10000}   filter={{ id : JSON.parse(localStorage.getItem("user")).Folder,
                                                 active : true }}  
                 actions={<PostShowActions />} bulkActionButtons={false}  >
         
            <Datagrid    >
              <TextField source="FullName" label="Folder" />
              <ListUserButton />
              <ListSubFoldersButton />
              <ListOutSubFoldersButton />
              <CreateDocumentButton />
              <ListDocumentsButton />
        </Datagrid>
        
    </List>
);
 
///
 /*
export const FolderList = (props) => (
    <List {...props} perPage={10000}     >
        <Tree  >
            <NodeView  >
                <TextField source="name" />

            </NodeView>
        </Tree>
    </List>
);
 */
///enableDragAndDrop dragPreviewComponent={TagDragPreview}
/*
export const FolderListAdmin = (props) => (
    <List {...props} perPage={10000}       >
        <Tree  >
            <NodeView  >
                <TextField source="name" />
            </NodeView>
        </Tree>
    </List>
);
*/
////

export const FolderListAdmin = (props) => (
    <List {...props}  perPage={10000} actions={<PostShowActions />} bulkActionButtons={false} 
                         filter={{ id : JSON.parse(localStorage.getItem("user")).Folder  }}     >
      <Datagrid >
            <TextField source="FullName" />
            <ListUserButton   />
            <EditFolderButton  />
            <ListSubFoldersButton />
            <ListOutSubFoldersButton /> 
            <CreateFolderButton />
            <CreateDocumentButton />
            <ListDocumentsButton    />
            <DeleteFolderButton />
        </Datagrid>
    </List>
);
 ///enableDragAndDrop dragPreviewComponent={TagDragPreview}
/*
export const FolderListOwner = (props) => (
    <List {...props} perPage={10000}     >
        <Tree  >
            <NodeView actions={<FoldersActions />}>
                <TextField source="name" />
            </NodeView>
        </Tree>
    </List>

<List {...props} perPage={100} filters={<FolderFilter />}   bulkActionButtons={false} ActionButtons={false} >
        <Datagrid    >
          <TextField source="id" />
            <TextField source="name"   label="Folder name" />
            <ListUserButton    />
            <EditFileButton />
            <CreateDocumentButton />
            <ListDocumentsButton    />  
        </Datagrid>
    </List>

);
*/
 
 /*
 <ReferenceInput source="client" reference="clients"  label="Client" fullWidth allowEmpty >
               <SelectInput optionText="name" />
            </ReferenceInput> 
            */

 ///
 export const FolderCreate = props => (
    <Create {...props}>
        <SimpleForm validate={validateFolderCreation} redirect="list">
            <div  style={styles.flex} fullWidth >
                <DisabledInput source="id" fullWidth  />
                <DisabledInput source="user" defaultValue={JSON.parse(localStorage.getItem("user")).id} fullWidth label='Created by' />
                <DisabledInput source="parent_id"   label='Container' fullWidth />
            </div>
            <TextInput source="name" fullWidth autoFocus />
                       
            <BooleanInput source="active" label="Viewable" defaultValue={true} />
        </SimpleForm>
    </Create>
);
///
 


///

const validateFolderCreation = (values) => {
    const errors = {};
    if (!values.name) {
        errors.name = ['The name is required'];
    }
  /*  if (!values.customer) {
        errors.customer = ['The customer is required'];
    }
    if (!values.administrator) {
        errors.administrator = ['The administrator is required'];
    }
    */
    return errors
};

/*
<ReferenceInput source="client" reference="clients"  label="Client" fullWidth allowEmpty >
               <SelectInput optionText="name" />
            </ReferenceInput>   
            */

///
export const FolderEdit = props => (
    <Edit title={<FolderTitle />} {...props}>
        <SimpleForm validate={validateFolderCreation} toolbar={<PostEditToolbar />}>
           <div  style={styles.flex} fullWidth >
                <DisabledInput source="id" fullWidth  />
                <DisabledInput source="user"  fullWidth label='Created by' />
                <DisabledInput source="parent_id"  label='Container'    fullWidth />
            </div>
            <TextInput source="name" fullWidth autoFocus />
                     
            <BooleanInput source="active" label="Viewable"  />
        </SimpleForm>
    </Edit>
);

////
const FolderTitle = ({ record }) => {
    return <span>Folder: {record ? `"${record.name}"` : ''}</span>;
};

///
const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />  
    </Toolbar>
);
/// 
  